import * as THREE from 'three'
import { SSAOPass } from "three/examples/jsm/postprocessing/SSAOPass";
import { EffectComposer } from "three/examples/jsm/postprocessing/EffectComposer.js";
import { RenderPass } from "three/examples/jsm/postprocessing/RenderPass.js";
import { ShaderPass } from "three/examples/jsm/postprocessing/ShaderPass.js";
import { FXAAShader } from "three/examples/jsm/shaders/FXAAShader.js";
import { HorizontalBlurShader } from "three/examples/jsm/shaders/HorizontalBlurShader.js";
import { VerticalBlurShader } from "three/examples/jsm/shaders/VerticalBlurShader.js";
import { OutlineEffect } from './OutlineEffect'

import Experience from './Experience.js'
import ThreeBSP from 'three-csg';

export default class Renderer
{
    constructor(shadowMapEnabled,shadowMapType,physicallyCorrectLights,antialias)
    {
        this.experience = new Experience()
        this.canvas = this.experience.canvas
        this.sizes = this.experience.sizes
        this.scene = this.experience.scene
        this.camera = this.experience.camera
        function onMousemove() {
        
        }
        
        // this.setInstance(physicallyCorrectLights,shadowMapEnabled,antialias)
    }

     setInstance(physicallyCorrectLights,shadowMapEnabled,antialias)
    {
                this.instance = new THREE.WebGLRenderer({
            antialias: true,
            canvas:this.canvas
        })
        this.instance.physicallyCorrectLights = physicallyCorrectLights
        this.instance.outputColorSpace = THREE.SRGBColorSpace
        this.instance.toneMapping = THREE.ACESFilmicToneMapping
        this.instance.shadowMap.enabled = shadowMapEnabled
        this.instance.shadowMap.type = THREE.PCFSoftShadowMap
        this.instance.setSize(this.sizes.width, this.sizes.height)
        this.instance.setPixelRatio(Math.min(this.sizes.pixelRatio, 2))
        this.effect = new OutlineEffect( this.instance );
       
    }

    





    resize()
    {
        this.instance.setSize(this.sizes.width, this.sizes.height)

        this.instance.setPixelRatio(Math.min(this.sizes.pixelRatio, 2))
    }
   
    update()
    {
        
        this.instance.render(this.scene, this.camera.instance)
// this.effect.render( this.scene, this.camera.instance );

    }
    
   
}